module.exports = __webpack_public_path__ + "img/multiple-payment-option.5c9c529d.jpg";